import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useGhgScopesQuery } from "API";

import useFilterParam from "./useFilterParam";

const Scope: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("scope");

  const { data = [], isSuccess, isError } = useGhgScopesQuery();
  const [selected, setSelected] = useFilterParam("scope", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!data.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      translate={translate}
    />
  );
};

export default Scope;
